// src/i18n.js
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import translationEN from './locales/en/translation.json';
import translationFA from './locales/fa/translation.json';
import translationAR from './locales/ar/translation.json';

const resources = {
  fa: { translation: translationFA },
  en: { translation: translationEN },
  ar: { translation: translationAR },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
   .init({
    resources,
    fallbackLng: 'fa', // Fallback if detected language is not available
    detection: {
      // order: ['querystring','localStorage' , 'cookie', 'sessionStorage', 'navigator', 'htmlTag'],
      order: ['querystring','localStorage' ],
      // caches: ['cookie'], // Optional: Store language preference
    },
    supportedLngs: ['fa', 'en', 'ar'], // List of supported languages
  // lng: 'fa', // Force default language (overrides browser detection)
    caches: ['localStorage'], 
   interpolation: {
      escapeValue: false,
    },
  });
  // .init({
  //   resources,
  //   // lng: 'fa', // Hardcoded default
  //   fallbackLng: 'fa',
  //   interpolation: {
  //     escapeValue: false,
  //   },
  // });

export default i18n;
